<!--
 * @Author: SunFulin
 * @createDate: Do not edit
 * @LastEditTime: 2021-04-13 20:44:03
-->
<template>
  <div class="errCode">
    <div class="logo"></div>
    <div class="content">
      404
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {};
  },
  methods: {},
  mounted() {},
};
</script>
<style lang="less" scoped>
@font-size-base: 75;
.errCode {
  position: relative;
  width: 100vw;
  height: 100vh;
  font-size: 15rem / @font-size-base;
  .logo {
    position: absolute;
    top: 30%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 708rem / @font-size-base;
    height: 571.3rem / @font-size-base;
    background: url('../../assets/images/h5/err404.png') no-repeat;
    background-size: auto 100%;
  }
  .content {
    width: 100%;
    position: absolute;
    top: 45%;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    font-size: 100rem / @font-size-base;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #c4c4c4;
    line-height: 41rem / @font-size-base;
  }
}
</style>
